import { render } from "./presentor.vue?vue&type=template&id=dadd30ba&scoped=true"
import script from "./presentor.vue?vue&type=script&lang=js"
export * from "./presentor.vue?vue&type=script&lang=js"

import "./presentor.vue?vue&type=style&index=0&id=dadd30ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dadd30ba"

export default script